export default "__VITE_ASSET__ixaS55R0__"